/**
 * Rivaaz brand logo (transparent PNG, displayed as-is on any background).
 * className lets callers control sizing.
 *
 * Note: the `blend` prop is preserved for backwards compatibility but is now
 * a no-op — the new logo art is already alpha-transparent and doesn't need
 * any mix-blend trickery to dissolve a background.
 */
export default function Logo({ className = "h-10 w-auto", inverted: _inverted = false, blend: _blend = false, ...props }) {
  return (
    <img
      src="/brand/rivaaz-logo.png"
      alt="Rivaaz Indian Pizza & Cuisine"
      className={`${className} select-none drop-shadow-[0_2px_6px_rgba(0,0,0,0.45)]`}
      draggable={false}
      {...props}
    />
  );
}
